import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/ntimev1/$")({
    beforeLoad: ({ location }) => {
        throw redirect({
            to: location.pathname.replace(/^\/ntimev1[/\\]*/i, "/"),
            search: location.search,
            hash: location.hash,
            replace: true,
        });
    },
});
